/**
 * Fix text wrapping for "The Heritage Collection - Made in Italy" in mobile navigation
 * Ensures the text breaks only after the dash, not word by word
 * Safari compatible implementation
 */
(function() {
  'use strict';

  // Safari detection
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  function fixHeritageTextWrapping() {
    // Only run on mobile screen sizes
    if (window.innerWidth > 767) {
      return;
    }

    // Target all navigation links in mobile drawer
    var mobileNavLinks = document.querySelectorAll('.mobile-navigation-drawer .navigation__tier-1 > .navigation__item > .navigation__link');

    // If no mobile nav links found, don't proceed
    if (mobileNavLinks.length === 0) {
      return;
    }

    mobileNavLinks.forEach(function(link) {
      var text = link.textContent.trim();

      // Check if this is the Heritage Collection link
      if (text.includes('The Heritage Collection - Made in Italy')) {
        // Reset to original text first
        if (!link.dataset.originalText) {
          link.dataset.originalText = text;
        }
        link.innerHTML = link.dataset.originalText;

        // Check if text overflows by temporarily setting it to nowrap
        link.style.whiteSpace = 'nowrap';
        var isOverflowing = link.scrollWidth > link.clientWidth;

        if (isOverflowing) {
          // Only break the line if text actually overflows
          link.innerHTML = 'The Heritage Collection -<br>Made in Italy';
          link.classList.add('heritage-text-wrapped');
        } else {
          // Keep on one line if it fits
          link.classList.remove('heritage-text-wrapped');
        }

        // Reset white-space to normal for proper styling
        link.style.whiteSpace = '';

        // Force reflow to ensure Safari applies the styles
        if (isSafari) {
          link.style.display = 'none';
          link.offsetHeight; // Force reflow
          link.style.display = '';
        }
      }
    });
  }

  function cleanupMobileNavigation() {
    // Remove any mobile-specific modifications when switching to desktop
    var allNavLinks = document.querySelectorAll('.navigation__link.heritage-text-wrapped');
    allNavLinks.forEach(function(link) {
      if (link.dataset.originalText) {
        link.innerHTML = link.dataset.originalText;
        link.classList.remove('heritage-text-wrapped');
        link.style.whiteSpace = '';
      }
    });
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixHeritageTextWrapping);
  } else {
    fixHeritageTextWrapping();
  }

  // Also run when mobile navigation is opened (in case it's loaded dynamically)
  document.addEventListener('click', function(e) {
    if (e.target && (e.target.closest('.mobile-nav-link') || e.target.closest('.mobile-navigation__toggle'))) {
      // Small delay to ensure the mobile nav is rendered
      setTimeout(fixHeritageTextWrapping, 100);
    }
  });

  // Enhanced resize handler for all resolution changes
  var resizeTimeout;
  var lastWidth = window.innerWidth;
  var lastHeight = window.innerHeight;

  function handleResolutionChange() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      var currentWidth = window.innerWidth;
      var currentHeight = window.innerHeight;

      // Check if resolution actually changed (not just scroll on mobile)
      if (currentWidth !== lastWidth || currentHeight !== lastHeight) {
        lastWidth = currentWidth;
        lastHeight = currentHeight;

        // Apply fix on mobile, cleanup on desktop
        if (currentWidth <= 767) {
          fixHeritageTextWrapping();
        } else {
          cleanupMobileNavigation();
        }
      }
    }, 200); // Balanced response time to prevent excessive recalculations
  }

  // Listen to multiple events for comprehensive resolution change detection
  window.addEventListener('resize', handleResolutionChange);
  window.addEventListener('orientationchange', function() {
    // Orientation change needs a longer delay as mobile browsers adjust slowly
    setTimeout(function() {
      handleResolutionChange();
      // Double-check after orientation stabilizes
      setTimeout(function() {
        if (window.innerWidth <= 767) {
          fixHeritageTextWrapping();
        } else {
          cleanupMobileNavigation();
        }
      }, 500);
    }, 200);
  });

  // Listen for zoom changes (visual viewport API if available)
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', handleResolutionChange);
  }

  // Additional event listener for when mobile navigation becomes visible
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        var target = mutation.target;
        if (target.classList && target.classList.contains('reveal-mobile-nav')) {
          setTimeout(fixHeritageTextWrapping, 150);
        }
      }
    });
  });

  // Observe body class changes for mobile nav visibility
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });

  // Cleanup function to prevent memory leaks
  function cleanup() {
    // Disconnect MutationObserver
    if (observer) {
      observer.disconnect();
    }

    // Clear any pending timeouts
    if (resizeTimeout) {
      clearTimeout(resizeTimeout);
    }

    // Remove event listeners
    window.removeEventListener('resize', handleResolutionChange);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', handleResolutionChange);
    }
  }

  // Cleanup on page unload or navigation
  window.addEventListener('beforeunload', cleanup);
  window.addEventListener('pagehide', cleanup);

  // For SPAs that might not trigger beforeunload
  if (typeof document.addEventListener === 'function') {
    document.addEventListener('visibilitychange', function() {
      if (document.visibilityState === 'hidden') {
        cleanup();
      }
    });
  }

})();